import {
  AcceptInviteRequestSchema,
  AcceptInviteResponseSchema,
  CreateCollectionRequestSchema,
  CreateCollectionResponseSchema,
  CreateInviteRequestSchema,
  CreateInviteResponseSchema,
  DataService,
  DeleteAccountRequestSchema,
  DeleteAccountResponseSchema,
  DeleteCollectionRequestSchema,
  DeleteCollectionResponseSchema,
  GetAccountRequestSchema,
  GetAccountResponseSchema,
  GetAviationWeatherRequestSchema,
  GetAviationWeatherResponseSchema,
  GetCollectionRequestSchema,
  GetCollectionResponseSchema,
  GetCurrentUserRequestSchema,
  GetCurrentUserResponseSchema,
  GetInviteRequestSchema,
  GetInviteResponseSchema,
  GetOsmTagsRequestSchema,
  GetOsmTagsResponseSchema,
  GetSharingRequestSchema,
  GetSharingResponseSchema,
  GetTimeZoneRequestSchema,
  GetTimeZoneResponseSchema,
  ListCollectionsRequestSchema,
  ListCollectionsResponseSchema,
  RevokeInviteRequestSchema,
  RevokeInviteResponseSchema,
  SaveRequestSchema,
  SaveResponseSchema,
  SearchRequestSchema,
  SearchResponseSchema,
  SetAnyoneCanViewRequestSchema,
  SetAnyoneCanViewResponseSchema,
  SetGrantRequestSchema,
  SetGrantResponseSchema,
  SetViewStateRequestSchema,
  SetViewStateResponseSchema,
  UpdateCollectionRequestSchema,
  UpdateCollectionResponseSchema,
} from 'trails_lat/proto/data_pb';

export const BACKENDS = {
  'lat.trails.DataService': {
    service: DataService,
    methods: {
      acceptInvite: [AcceptInviteRequestSchema, AcceptInviteResponseSchema],
      createCollection: [CreateCollectionRequestSchema, CreateCollectionResponseSchema],
      createInvite: [CreateInviteRequestSchema, CreateInviteResponseSchema],
      deleteAccount: [DeleteAccountRequestSchema, DeleteAccountResponseSchema],
      deleteCollection: [DeleteCollectionRequestSchema, DeleteCollectionResponseSchema],
      getAccount: [GetAccountRequestSchema, GetAccountResponseSchema],
      getAviationWeather: [GetAviationWeatherRequestSchema, GetAviationWeatherResponseSchema],
      getCollection: [GetCollectionRequestSchema, GetCollectionResponseSchema],
      getCurrentUser: [GetCurrentUserRequestSchema, GetCurrentUserResponseSchema],
      getInvite: [GetInviteRequestSchema, GetInviteResponseSchema],
      getOsmTags: [GetOsmTagsRequestSchema, GetOsmTagsResponseSchema],
      getSharing: [GetSharingRequestSchema, GetSharingResponseSchema],
      getTimeZone: [GetTimeZoneRequestSchema, GetTimeZoneResponseSchema],
      listCollections: [ListCollectionsRequestSchema, ListCollectionsResponseSchema],
      revokeInvite: [RevokeInviteRequestSchema, RevokeInviteResponseSchema],
      save: [SaveRequestSchema, SaveResponseSchema],
      search: [SearchRequestSchema, SearchResponseSchema],
      setAnyoneCanView: [SetAnyoneCanViewRequestSchema, SetAnyoneCanViewResponseSchema],
      setGrant: [SetGrantRequestSchema, SetGrantResponseSchema],
      setViewState: [SetViewStateRequestSchema, SetViewStateResponseSchema],
      updateCollection: [UpdateCollectionRequestSchema, UpdateCollectionResponseSchema],
    },
  },
} as const;
